<template>
  <yd-dialog
    :title="form.id ? '编辑' : '新增'"
    :visible.sync="showVisible"
    append-to-body
    @close="closeEdit"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      style="margin-left: 30px; margin-right: 10px"
      size="mini"
      label-position="left"
      label-width="110px"
    >
      <el-form-item :label="type === 4 ? 'icon名称' : '广告名称'" prop="name">
        <el-input
          type="text"
          :placeholder="`不超过${type === 4 ? 5 : 10}个字`"
          v-model="form.name"
          :maxlength="type === 4 ? 5 : 10"
          show-word-limit
          style="width: 300px"
          v-no-space
          v-no-emoji
        />
      </el-form-item>
      <el-form-item
        v-if="clientType === 1"
        :label="type === 4 ? '位置' : '广告位置'"
        prop="locationKey"
      >
        <!--        type === 4-->
        <el-select
          v-model="form.locationKey"
          placeholder="请选择"
          :disabled="true"
          clearable
          style="width: 300px"
        >
          <el-option
            v-for="item in locationList"
            :key="item.advertisingLocationKey"
            :label="item.advertisingLocationDesc"
            :value="item.advertisingLocationKey"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="type === 5" :label="'展示页面'" prop="displayPage">
        <el-select v-model="form.displayPage" placeholder="请选择" clearable style="width: 300px">
          <el-option
            v-for="item in pageEnumList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="type === 3 || type === 4 || type === 5"
        :label="type === 4 ? '排序' : '权重'"
        prop="sort"
      >
        <div style="display: flex; align-items: center">
          <!--          <el-input-->
          <!--            type="number"-->
          <!--            placeholder="请输入整数"-->
          <!--            v-model.number="form.sort"-->
          <!--            style="width: 300px"-->
          <!--          />-->
          <el-input-number v-model="form.sort" :min="1" :max="type === 4 ? 'Infinity' : 10" />
          <span class="form-tip" style="width: 300px" v-if="type !== 4">数值越小，优先级越高</span>
        </div>
      </el-form-item>
      <el-form-item
        required
        label="展示地区"
        v-if="type === 5 || type === 4 || type === 2"
        :prop="form.allArea === 1 ? 'allArea' : 'locationId'"
      >
        <div>
          <el-radio-group v-model="form.allArea">
            <el-radio :label="1">全部地区</el-radio>
            <el-radio :label="0">部分地区</el-radio>
          </el-radio-group>
        </div>
        <YdCitySelect
          v-if="form.allArea !== 1"
          mode="2"
          placeholder="请选择地级归属"
          :customHttp="getDriverAreaTree"
          :fieldFormat="fieldFormat"
          v-model="form.locationId"
        />
      </el-form-item>
      <el-form-item label="活动时间" required>
        <el-date-picker
          v-model="form.startTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="开始日期"
          :picker-options="pickerOptionStart()"
          style="width: 200px"
        />
        <span>-</span>
        <el-date-picker
          v-model="form.endTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="结束日期"
          :picker-options="pickerOptionEnd()"
          style="width: 200px"
          @change="dataPickerChange"
        />
      </el-form-item>
      <el-form-item v-if="type !== 1" label="图片" prop="imgUrl" required>
        <!-- <div v-if="type !== 4"> -->
        <div v-if="type !== 4 || clientType === 2">
          <upload-image
            :file="fileList"
            :instructionText="`jpg/png/gif格式，大小${imgSize[0]}*${imgSize[1]}，不超过1M。`"
            @uploadSuccess="(url) => getImgUrl(url)"
            @remove="handleRemove('ios')"
            :width="imgSize[0]"
            :height="imgSize[1]"
            :fileSize="1024"
            :code="codeType"
          />
        </div>
        <div v-else class="flex">
          <el-image
            v-if="form.imgUrl"
            style="width: 100px; height: 100px"
            :src="form.imgUrl"
            :preview-src-list="[form.imgUrl]"
          />
          <div class="margin-left-10">
            <el-button type="text" @click="changeImg">
              {{ form.imgUrl ? '更换图片' : '新增图片' }}
            </el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="clientType !== 1 && type === 1"
        label="Android图片"
        prop="imgUrl"
        required
      >
        <upload-image
          :file="androidFile"
          :instructionText="'jpg/png/gif格式，大小1080*1920，不超过500kb。'"
          @uploadSuccess="(url) => getImgUrl(url, 'android')"
          @remove="handleRemove('android')"
          :width="1080"
          :height="1920"
          :code="codeType"
        />
      </el-form-item>
      <el-form-item v-if="clientType !== 1 && type === 1" label="IOS图片" prop="imgUrl" required>
        <upload-image
          :file="iosFile"
          :instructionText="'jpg/png/gif格式，大小750*1334，不超过500kb。'"
          @uploadSuccess="(url) => getImgUrl(url, 'ios')"
          @remove="handleRemove('ios')"
          :width="750"
          :height="1334"
          :code="codeType"
        />
      </el-form-item>
      <el-form-item v-if="clientType !== 1 && type === 1" label="自定义图片">
        <el-button type="primary" @click="addCustom" v-if="customImage.length < 4">添加</el-button>
        <div style="display: flex; margin-top: 10px">
          <upload-image
            v-for="item in customImage"
            :key="item.uuid"
            :file="item.file"
            :instructionText="item.instructionText"
            @uploadSuccess="(url) => getImgUrl(url, 'custom', item)"
            @remove="handleRemove('custom', item)"
            :code="codeType"
          />
        </div>
      </el-form-item>
      <el-form-item label="跳转页面" prop="pageUrl">
        <el-input v-model.trim="form.pageUrl" placeholder="请输入链接" style="width: 300px" />
      </el-form-item>
      <el-form-item
        v-if="clientType === 1"
        label="跳转类型"
        :prop="type === 4 ? 'pageUrlType' : ''"
      >
        <el-radio-group v-model="form.pageUrlType">
          <el-radio :label="2">外部链接</el-radio>
          <el-radio :label="1">乘客端内部页面</el-radio>
          <el-radio :label="3">其他小程序（仅在微信小程序生效）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.pageUrlType === 3" label="APPID" prop="appId">
        <el-input v-model.trim="form.appId" placeholder="请输入APPID" style="width: 300px" />
      </el-form-item>
      <el-form-item v-if="form.pageUrlType === 3" label="账号原始ID" prop="appletOriginalId">
        <el-input
          v-model.trim="form.appletOriginalId"
          placeholder="请输入账号原始ID"
          style="width: 300px"
        />
      </el-form-item>
      <el-form-item v-if="clientType === 1" label="展示渠道" prop="displayChannelList">
        <el-checkbox-group v-model="form.displayChannelList">
          <el-checkbox label="1">微信小程序</el-checkbox>
          <el-checkbox label="2">APP</el-checkbox>
          <el-checkbox label="3">云闪付</el-checkbox>
          <el-checkbox label="4">支付宝小程序</el-checkbox>
          <!-- 暂时只在banner 使用 -->
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEdit">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>
    <imageGallery
      v-if="imgShow"
      :visible="imgShow"
      @closeChoose="closeChoose"
      @saveImage="saveImage"
    />
  </yd-dialog>
</template>

<script>
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  import { uuidv5 } from '@/util/util'
  import UploadImage from './upload-image'
  import { isEmpty } from 'lodash-es'
  import imageGallery from './image-gallery.vue'
  import { getDriverAreaTree } from '@/api/vehicle/vehicle-manage'
  import { getPageEnumList } from '../../../../api/marketing/advertising'
  import dayjs from 'dayjs'
  const codeMap = {
    1: 'advertising',
    2: 'popup',
    3: 'banner',
    4: 'icon-driver',
    5: 'banner'
  }
  export default {
    components: {
      UploadImage,
      imageGallery
    },
    props: {
      type: {
        type: Number,
        default: 0 // 1为开屏页，2为弹窗，3为banner，4为icon
      },
      clientType: {
        type: Number,
        default: 0 // 1为乘客端，2为司机端，3为云滴管家
      },
      visible: {
        type: Boolean,
        default: false
      },
      locationList: {
        type: Array,
        default: () => []
      },
      advertisingInfo: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        getDriverAreaTree,
        pickerBeginOption: {
          disabledDate: (time) => {
            console.log(time)
            return Date.now() - 3600 * 1000 * 24 > time.getTime()
          }
        },
        doUpload: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        headers: {
          Authorization: 'Bearer ' + getToken()
        },
        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback()
                  return
                }

                // 使用更精确的表情符号检测方法
                // 这个正则表达式专门匹配表情符号，不会误判数字
                const emojiRegex =
                  /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u

                if (emojiRegex.test(value)) {
                  callback(new Error('名称不能包含表情符号'))
                  return
                }

                callback()
              },
              trigger: 'blur'
            }
          ],
          locationKey: [{ required: true, message: '请选择位置', trigger: 'change' }],
          pageUrl: [
            { required: this.type === 4, message: '请输入跳转页面', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback()
                  return
                }

                // 使用更精确的表情符号检测方法
                // 这个正则表达式专门匹配表情符号，不会误判数字
                const emojiRegex =
                  /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u

                if (emojiRegex.test(value)) {
                  callback(new Error('跳转页面不能包含表情符号'))
                  return
                }

                callback()
              },
              trigger: 'blur'
            }
          ],
          pageUrlType: [{ required: true, message: '请选择跳转类型', trigger: 'change' }],
          displayChannelList: [
            { required: true, message: '请至少选择一个展示渠道', trigger: 'change' }
          ],
          sort: [
            { required: true, message: '请输入权重或排序', trigger: ['blur', 'change'] },
            {
              validator: (rule, value, callback) => {
                if (this.type === 4) {
                  callback()
                  return
                }
                if (!/^(?:[1-9]|10)$/.test(value)) {
                  callback(new Error('请输入小于等于10的正整数'))
                  return
                }
                callback()
              },
              trigger: ['blur', 'change']
            }
          ],
          appId: [
            { required: true, message: '请输入appId', trigger: 'blur' },
            { pattern: /^wx[a-z0-9]{16}/, message: 'appId输入有误', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback()
                  return
                }

                // 使用更精确的表情符号检测方法
                // 这个正则表达式专门匹配表情符号，不会误判数字
                const emojiRegex =
                  /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u

                if (emojiRegex.test(value)) {
                  callback(new Error('appId不能包含表情符号'))
                  return
                }

                callback()
              },
              trigger: 'blur'
            }
          ],
          appletOriginalId: [
            { required: true, message: '请输入账号原始ID', trigger: 'blur' },
            { pattern: /^gh_[a-z0-9]{12}/, message: '账号原始ID输入有误', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback()
                  return
                }

                // 使用更精确的表情符号检测方法
                // 这个正则表达式专门匹配表情符号，不会误判数字
                const emojiRegex =
                  /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u

                if (emojiRegex.test(value)) {
                  callback(new Error('账号原始ID不能包含表情符号'))
                  return
                }

                callback()
              },
              trigger: 'blur'
            }
          ],
          locationId: [{ required: true, message: '请选择展示地区', trigger: 'change' }],
          displayPage: [{ required: true, message: '请选择展示页面', trigger: 'change' }]
        },
        form: {
          startTime: '',
          endTime: '',
          name: '',
          locationKey: '',
          imgUrl: '',
          pageUrl: '',
          appletOriginalId: undefined,
          displayChannelList: [],
          displayChannel: '',
          allArea: 1,
          displayPage: '',
          sort: 1
        },
        uploadDisabled: false,
        fileList: [],
        androidImg: '',
        iosImg: '',
        customImage: [],
        androidFile: [],
        iosFile: [],
        showVisible: false,
        imgShow: false,
        ruleForm: null,
        pageEnumList: []
      }
    },
    computed: {
      codeType() {
        return codeMap[this.type]
      },
      imgSize() {
        if (this.type === 2) {
          return [580, 760]
        }
        if (this.type === 4 && this.clientType === 1) {
          return [80, 80]
        }
        if (this.type === 4 && this.clientType === 2) {
          return [320, 140]
        }
        if (this.clientType === 1) {
          if (this.type === 3 || this.type === 5) {
            if (this.form.locationKey === 'client:002') {
              return [690, 210]
            }
            return [750, 350]
          }
        }
        if (this.clientType === 2) {
          return [750, 360]
        }
        if (this.clientType === 3) {
          return [682, 324]
        }
        return [580, 760]
      }
    },
    watch: {
      'form.displayChannelList': {
        handler: function (newValue, oldValue) {
          if (!isEmpty(newValue)) {
            this.form.displayChannel = newValue.join(',')
          }
        },
        deep: true
      }
    },
    mounted() {
      // if (this.type === 4) {
      //   this.form.locationKey = 'client:001'
      // }
      // 全部默认选中首页
      this.form.locationKey = 'client:001'
      this.showVisible = this.visible
      if (!isEmpty(this.advertisingInfo)) {
        const { imgList, imgUrl } = this.advertisingInfo
        if (this.type === 1 && imgList) {
          this.androidFile.push({ url: imgList[0] })
          this.iosFile.push({ url: imgList[1] })
          this.uploadDisabled = true
          this.androidImg = imgList[0]
          this.iosImg = imgList[1]
          const customImage = imgList.slice(2)
          customImage.forEach((item) => {
            if (item) {
              const index = item.indexOf('?')
              const size = {}
              if (index !== -1) {
                const str = item.substr(index + 1)
                const strs = str.split('&')
                for (var i = 0; i < strs.length; i++) {
                  size[strs[i].split('=')[0]] = strs[i].split('=')[1]
                }
              }
              this.customImage.push({
                uuid: uuidv5(),
                height: size.height,
                width: size.width,
                url: item,
                instructionText: `${size.width} * ${size.height}`,
                file: [{ url: item }]
              })
            }
          })
        } else {
          this.fileList.push({ url: imgUrl })
        }
        this.form = {
          ...this.advertisingInfo,
          displayChannelList: []
        }
        if (this.form.displayChannel) {
          this.form.displayChannelList = this.form.displayChannel.split(',')
        }
        console.log('this.form.displayChannel', this.form)
      }
      getPageEnumList().then((res) => {
        const { code, data } = res
        if (code === 0) {
          this.pageEnumList = data.bannerDisplayPage || []
        }
      })
    },
    methods: {
      saveImage(url) {
        this.form.imgUrl = url
        this.closeChoose()
      },
      closeChoose() {
        this.imgShow = false
      },
      changeImg() {
        this.imgShow = true
      },
      pickerOptionStart() {
        return {
          // 日期限制
          disabledDate: (time) => {
            return Date.now() - 3600 * 1000 * 24 > time.getTime()
          }
        }
      },
      pickerOptionEnd() {
        // if (!this.form.startTime) {
        //
        // }
        return {
          // 日期限制
          disabledDate: (time) => {
            if (!this.form.startTime) {
              return Date.now() - 3600 * 1000 * 24 > time.getTime()
            }
            // 原本逻辑是向前推一天，改版 -> 当天之后的时间
            return time.getTime() < dayjs(this.form.startTime).startOf('day').valueOf()
          },
          // 添加自定义类名函数，移除今天高亮
          cellClassName: (time) => {
            // 如果已选择开始日期，且当前日期是今天，则添加自定义类名来覆盖今天的高亮效果
            if (this.form.startTime) {
              const start = dayjs(this.form.startTime).startOf('day').valueOf()
              const today = dayjs(new Date()).startOf('day').valueOf()
              if (start > today && dayjs(time).valueOf() === today) {
                return 'remove-today-highlight'
              }
            }
            return ''
          }
        }
      },
      getImgUrl(url, type, item) {
        if (type === 'android') {
          this.androidImg = url
        }
        if (type === 'ios') {
          this.iosImg = url
        }
        if (type === 'custom') {
          item.url = url
          const index = url.indexOf('?')
          if (index !== -1) {
            const str = url.substr(index + 1)
            const strs = str.split('&')
            for (var i = 0; i < strs.length; i++) {
              item[strs[i].split('=')[0]] = strs[i].split('=')[1]
            }
          }
          item.instructionText = `${item.width} * ${item.height}`
        }
        if (!type) {
          this.form.imgUrl = url
        }
      },
      handleRemove(type, item) {
        if (type === 'android') {
          this.androidImg = ''
        }
        if (type === 'ios') {
          this.iosImg = ''
        }
        if (type === 'custom') {
          item.url = ''
          item.width = 0
          item.height = 0
        }
        if (!type) {
          this.form.imgUrl = ''
        }
      },
      save() {
        if (!this.form.startTime || !this.form.endTime) {
          this.$message.info('请先选择活动时间！')
          return
        }
        const start = dayjs(this.form.startTime).valueOf()
        const end = dayjs(this.form.endTime).valueOf()
        if (end <= start) {
          this.$message.info('活动时间中结束时间不能小于或等于开始时间！')
          return
        }
        if (this.form.pageUrl) {
          this.form.pageUrl = this.form.pageUrl.replace(/\s+/g, '')
        }
        if (this.form.appId) {
          this.form.appId = this.form.appId.replace(/\s+/g, '')
        }
        if (this.clientType === 2) {
          this.form.locationKey = 'driver:001'
        }
        if (this.clientType === 3) {
          this.form.locationKey = 'oa:001'
        }
        if (this.type === 1) {
          if (!this.androidImg) {
            this.$message.info('请上传Android图片！')
            return
          }
          if (!this.iosImg) {
            this.$message.info('请上传IOS图片！')
            return
          }
          const img = this.customImage.map((item) => {
            return item.url
          })
          this.form.imgUrl = this.androidImg + ',' + this.iosImg
          if (img) {
            this.form.imgUrl = this.androidImg + ',' + this.iosImg + ',' + img.join()
          }
        }
        if (!this.form.imgUrl) {
          this.$message.info('请上传活动图片！')
          return
        }
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let areaIds = []
            const { locationId, allArea, ...rest } = this.form
            if (allArea === 0) {
              areaIds =
                locationId && locationId.length > 0
                  ? locationId.map((item) => item.at(-1))
                  : undefined
            }
            this.$emit('saveEdit', {
              ...rest,
              areaIds,
              allArea
            })
          } else {
            return false
          }
        })
      },
      closeEdit() {
        this.showVisible = false
        this.uploadDisabled = false
        this.form = {
          startTime: '',
          endTime: '',
          name: '',
          locationKey: 'client:001',
          imgUrl: '',
          pageUrl: ''
        }
        this.androidFile = []
        this.iosFile = []
        this.fileList = []
        this.androidImg = ''
        this.iosImg = ''
        this.customImage = []
        this.$emit('closeEdit')
      },
      getImgSize(imgFile) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(imgFile)
          reader.onload = function () {
            const image = new Image()
            image.src = reader.result
            image.onload = function () {
              resolve({
                width: this.width,
                height: this.height,
                src: this.src
              })
            }
          }
        })
      },
      addCustom() {
        if (this.customImage && this.customImage.length >= 4) {
          this.$message.warning('自定义图片最多可上传4张！')
          return
        }
        this.customImage.push({
          uuid: uuidv5(),
          height: 0,
          width: 0,
          url: '',
          instructionText: ''
        })
      },
      fieldFormat(data) {
        data.forEach((item) => {
          item.children &&
            item.children.forEach((child) => {
              child.children = null
            })
        })
        const search = (list) => {
          for (let i = 0; i < list.length; i++) {
            const { children } = list[i]
            if (Array.isArray(children) && children.length > 0) {
              list[i].childAreaManage = children
              search(children)
            }
          }
        }

        search(data)

        return data
      },
      dataPickerChange(time) {
        if (this.form.startTime) {
          const start = dayjs(this.form.startTime).valueOf()
          const end = dayjs(time).valueOf()
          if (start > end) {
            this.$message.info('结束时间不能小于开始时间，请重新选择')
            this.form.endTime = ''
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .disabled ::v-deep .el-upload--picture-card {
    display: none;
  }

  .disabled ::v-deep .el-upload__tip {
    margin-top: -10px;
  }

  .form-tip {
    font-size: 12px;
    color: red;
    line-height: 1.5;
    margin-left: 10px;
  }
</style>
